import {IGNORE_AUTO_LOGIN, ROUTES} from 'constants/routes';
import {generateId} from 'lib/generator';
import React, {useEffect, useState} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {usePromise} from 'react-use';
import {describeAuthError, isAnonymousAuth, oktaAuth} from 'services/auth.service';
import {reportDatadogAuthError} from 'services/datadog.service';

function AutoLogin(props) {
  const {children, ignoredPaths = IGNORE_AUTO_LOGIN} = props;

  const [state, setState] = useState({key: generateId(), renderChildren: false});

  const history = useHistory();
  const location = useLocation();
  const mounted = usePromise();

  const brokerPortalRedirectEnable = window.env.REACT_APP_BROKER_PORTAL_REDIRECT_ENABLE === 'true';

  if (brokerPortalRedirectEnable && window.top === window.self) {
    const pathname = window.location.pathname;

    if (!/widgets/gi.test(pathname) && !/pdf/gi.test(pathname)) {
      window.location.href = `${window.env.REACT_APP_BROKER_PORTAL_URL}/illustrator/scenario`;
    }
  }

  useEffect(() => {
    (async function () {
      const renderChildren = await mounted(
        new Promise(async (resolve) => {
          try {
            const skipAutoLogin = ignoredPaths.find((path) => new RegExp(path, 'gi').test(window.location));

            if (skipAutoLogin) {
              return resolve(true);
            }

            if (oktaAuth.isLoginRedirect()) {
              try {
                await oktaAuth.handleLoginRedirect();
              } catch (ex) {
                if (!isAnonymousAuth(ex)) {
                  const described = describeAuthError(ex);
                  console.error('AutoLogin handleLoginRedirect failed', described, ex);
                  reportDatadogAuthError(ex, {source: 'AutoLogin.handleLoginRedirect'});
                  history.push(ROUTES.AUTH_ERROR_PAGE, {error: described});
                }
              }

              return resolve(true);
            }

            if (!(await oktaAuth.isAuthenticated())) {
              oktaAuth.setOriginalUri(location.pathname);
              await oktaAuth.signInWithRedirect({
                prompt: 'none',
              });
              return resolve(false);
            }

            oktaAuth.authStateManager.updateAuthState();

            return resolve(true);
          } catch (ex) {
            if (isAnonymousAuth(ex)) {
              return resolve(true);
            }

            const described = describeAuthError(ex);
            console.error('AutoLogin failed', described, ex);
            reportDatadogAuthError(ex, {source: 'AutoLogin'});
            history.push(ROUTES.AUTH_ERROR_PAGE, {error: described});
            return resolve(true);
          }
        }),
      );
      // This line will not execute if <AutoLogin> component gets unmounted.
      setState({key: generateId(), renderChildren});
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <React.Fragment key={state.key}>{state.renderChildren ? children : null}</React.Fragment>;
}

export default AutoLogin;
